import { Link } from 'react-router-dom'

const FaqCollapse = ({ faq }) => {
  return (
    <div className="collapse collapse-arrow bg-base-100 border-base-300 border">
      <input type="radio" name="my-accordion-2" />
      <div className="collapse-title py-5">{faq.query}</div>
      <div className="collapse-content text-sm">
        {faq.image ? (
          <div className="flex flex-col md:flex-row gap-5 lg:gap-10">
            <div className="basis-1/2 lg:basis-3/4">
              <div>{faq.answer}</div>
              {faq.link && (
                <div className="mt-5">
                  <Link
                    className="text-center py-2 px-5 border border-gray-300 rounded-full hover:bg-gray-100 text-xs"
                    to={faq.link}
                  >
                    詳細はこちらから
                  </Link>
                </div>
              )}
            </div>
            <div className="basis-1/2 lg:basis-1/4">
              <img src={faq.image} alt="" />
            </div>
          </div>
        ) : (
          <div>{faq.answer}</div>
        )}
      </div>
    </div>
  )
}

export default FaqCollapse
